export default {
      id: "icon-register-big-usage",
      viewBox: "0 0 95 103",
      url: __webpack_public_path__ + "icons.svg#icon-register-big",
      toString: function () {
        return this.url;
      }
    }